// extracted by mini-css-extract-plugin
export default {"wrapper":"styles_wrapper__bc0-G","title":"styles_title__ZtjaN"};